/* Beneos PDP commerce: dynamic resolver-driven price + "you get / you already own" checklist +
   Spec-8 cart building (qty x price_class variant with hidden _cloud_upload_ids line item props).

   Activates ONLY when the product is a shop_pseudo_product, i.e. carries custom.cloud_products;
   otherwise the standard static buy box (beneos.js) stays in charge. Nothing here is baked into
   cached HTML: price + checklist come live from the resolver so an ownership change / tag change
   takes effect immediately (Spec 5). Prices are read from the Liquid-rendered price_class map,
   which Shopify Markets already localises per market. */
(function () {
  var dataEl = document.getElementById('beneos-commerce-data');
  if (!dataEl) return;
  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var cps = (cfg.cloudProducts || []).filter(Boolean);
  if (!cps.length) return; // not a commerce product -> leave the static buy box alone

  var B = window.Beneos || {};
  var routes = B.routes || {};
  var proxyUrl = cfg.proxyUrl || '/apps/beneos/library';
  var priceMap = cfg.priceMap || {};
  var strings = cfg.strings || {};
  var form = document.querySelector('form[data-cart-form]');
  var addBtn = form ? form.querySelector('[data-add-btn]') : null;
  var priceEl = document.getElementById('pPrice');
  var checklistEl = document.getElementById('beneos-checklist');
  var resolved = null;

  // Hold the buy button until the resolver answers so a fast click can't post the wrong line.
  if (addBtn) addBtn.disabled = true;

  function numId(gid) { return String(gid == null ? '' : gid).replace(/\D/g, ''); }
  function money(cents) {
    if (B.cart && typeof B.cart.formatMoney === 'function') return B.cart.formatMoney(cents);
    return (Math.round(cents) / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function buildSummary(f, s) {
    if (!f || typeof f !== 'object') return '';
    s = s || {};
    var parts = [];
    if (f.battlemaps > 0) parts.push(f.battlemaps + ' ' + (s.s_maps || 'maps'));
    if (f.sceneries > 0) parts.push(f.sceneries + ' ' + (s.s_sceneries || 'sceneries'));
    if (f.handouts > 0) parts.push(f.handouts + ' ' + (s.s_handouts || 'handouts'));
    // asset packs (pack_facts payload instead of bm_facts.stats)
    if (f.creatures > 0) parts.push(f.creatures + ' ' + (s.s_creatures || 'creatures'));
    if (f.spells > 0) parts.push(f.spells + ' ' + (s.s_spells || 'spells'));
    if (f.items > 0) parts.push(f.items + ' ' + (s.s_items || 'items'));
    return parts.join(' · ');
  }

  // There is no static fallback any more. Until 2026-10-28 a failed or empty answer re-enabled
  // the button, the form then posted the shell's own variant (price 0, no package ids), and
  // the buyer checked out an order that unlocked nothing. Now a failure says so and offers a
  // retry; the button only ever adds what the resolver returned.
  var url = proxyUrl + (proxyUrl.indexOf('?') >= 0 ? '&' : '?') +
    'resource=resolve&cp=' + encodeURIComponent(cps.join(','));
  var loading = false;
  function load() {
    if (loading) return;
    loading = true;
    resolved = null;
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-add-label') || addBtn.textContent; }
    showNote('');
    fetch(url, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        if (!j || !j.data || typeof j.data !== 'object') throw new Error('no data');
        resolved = j.data;
        render(resolved);
      })
      .catch(function () { failed(); })
      .then(function () { loading = false; });
  }
  function failed() {
    resolved = null;
    showNote(strings.load_failed || 'The price could not be loaded.');
    if (addBtn) { addBtn.disabled = false; addBtn.textContent = strings.retry_label || 'Try again'; }
  }
  var noteEl = null;
  function showNote(text) {
    if (!noteEl && text && form) {
      noteEl = document.createElement('p');
      noteEl.className = 'bc-note';
      noteEl.setAttribute('role', 'status');
      form.insertAdjacentElement('afterend', noteEl);
    }
    if (noteEl) { noteEl.textContent = text; noteEl.hidden = !text; }
  }
  wireCart();
  load();

  function render(d) {
    var groups = d.groups || [];
    var priceable = true, total = 0;
    groups.forEach(function (g) {
      var p = priceMap[numId(g.variant_id)];
      if (p == null) { priceable = false; return; }
      total += p * (g.qty || 0);
    });
    var ownsAll = (d.delta_count || 0) === 0 && (d.total_uploads || 0) > 0;
    if (priceEl) {
      if (ownsAll) priceEl.textContent = strings.owned_all || 'You already own this';
      else if (priceable) priceEl.textContent = money(total);
    }
    // Bundle discount: curated bundles resolve to the cheaper bundle price classes and
    // carry full_groups (the same quantities in the regular classes). Show the full sum
    // struck through plus the saving percentage right next to the live price.
    if (priceEl && priceable && !ownsAll) {
      var saveEl = document.getElementById('bc-bundle-save');
      var fullOk = !!(d.bundle_pricing && (d.full_groups || []).length);
      var fullTotal = 0;
      (d.full_groups || []).forEach(function (g) {
        var p = priceMap[numId(g.variant_id)];
        if (p == null) { fullOk = false; return; }
        fullTotal += p * (g.qty || 0);
      });
      if (fullOk && fullTotal > total) {
        if (!saveEl) {
          saveEl = document.createElement('span');
          saveEl.id = 'bc-bundle-save';
          saveEl.className = 'bc-bundle-save';
          priceEl.insertAdjacentElement('afterend', saveEl);
        }
        var pct = Math.round((1 - total / fullTotal) * 100);
        saveEl.innerHTML = '<s>' + money(fullTotal) + '</s><span class="bc-save-pct">-' + pct + '%</span>';
      } else if (saveEl) {
        saveEl.remove();
      }
    }
    // Transparent partial-ownership pricing: reconstruct the full price from the owned
    // items' price_class variants and show "was X" struck through plus the deducted
    // amount, so the buyer sees they never pay twice for the same asset.
    if (priceEl && priceable && !ownsAll) {
      var ownedTotal = 0, ownedOk = true;
      (d.owned || []).forEach(function (o) {
        var p = priceMap[numId(o.variant_id)];
        if (p == null) { ownedOk = false; return; }
        ownedTotal += p;
      });
      var was = document.getElementById('bc-was');
      if (ownedOk && ownedTotal > 0) {
        if (!was) {
          was = document.createElement('div');
          was.id = 'bc-was';
          was.className = 'bc-was';
          var line = priceEl.closest('.priceline') || priceEl.parentNode;
          if (line && line.parentNode) line.parentNode.insertBefore(was, line.nextSibling);
        }
        var tpl = strings.deducted || '{amount} deducted for content you already own';
        was.innerHTML = '<s>' + money(total + ownedTotal) + '</s> <span class="bc-deduct"><span class="chk">✓</span> ' +
          esc(tpl.replace('{amount}', money(ownedTotal))) + '</span>';
      } else if (was) {
        was.remove();
      }
    }
    renderChecklist(d);
    markBundleOwned(d);
    if (addBtn) {
      if (ownsAll) {
        addBtn.disabled = true;
        addBtn.textContent = strings.owned_label || 'Owned';
      } else if (!groups.length) {
        // Not owned, yet nothing to put in the cart: the only line left would be the bare shell.
        addBtn.disabled = true;
        showNote(strings.unavailable || 'This pack cannot be bought right now.');
      } else {
        addBtn.disabled = false;
      }
    }
  }

  // Bundle PDP: badge the member releases the buyer already owns (green box, gold check)
  // and reveal the "owned content is deducted from the price" note. The section carries
  // the localized labels as data attributes; matching runs on the release name, which is
  // identical between the resolver's owned[] entries and the bundle_members titles.
  function markBundleOwned(d) {
    var root = document.getElementById('beneos-bundle-contents');
    if (!root) return;
    var ownedNames = {};
    (d.owned || []).forEach(function (o) {
      if (o && o.name) ownedNames[String(o.name).toLowerCase()] = true;
    });
    var ownedLabel = root.getAttribute('data-l-owned') || 'Already owned';
    var hits = 0;
    root.querySelectorAll('[data-bnd-name]').forEach(function (el) {
      var nm = (el.getAttribute('data-bnd-name') || '').toLowerCase();
      if (!ownedNames[nm]) return;
      hits++;
      if (!el.querySelector('.bnd-owned')) {
        var head = el.querySelector('.bnd-head');
        if (head) {
          var b = document.createElement('span');
          b.className = 'bnd-owned';
          b.innerHTML = '<span class="chk">✓</span> ' + esc(ownedLabel);
          head.appendChild(b);
        }
      }
    });
    var note = root.querySelector('[data-bnd-reduced]');
    if (note && hits > 0) note.hidden = false;
  }

  function renderChecklist(d) {
    if (!checklistEl) return;
    // On bundle pages the member rows carry data-bnd-name/-handle; link each checklist
    // entry to its release page so "What you get" doubles as navigation.
    function memberHandleFor(name) {
      if (!name || !window.CSS || !CSS.escape) return '';
      var el = document.querySelector('#beneos-bundle-contents .bnd-rel[data-bnd-name="' + CSS.escape(name) + '"]');
      // Hidden rows are drafted/unpublished members: keep the entry (it ships with the
      // purchase) but do not link to a product page that would 404.
      if (!el || el.style.display === 'none') return '';
      return el.getAttribute('data-bnd-handle') || '';
    }
    // Bundle mode (the member accordion exists): no per-line type chips; instead the
    // header carries the type totals, e.g. "What you get: 48 Map Packs".
    var bundleMode = !!document.getElementById('beneos-bundle-contents');
    function typeSummary(items) {
      var counts = {};
      items.forEach(function (it) {
        var t = (it.type || '').toLowerCase() || 'item';
        counts[t] = (counts[t] || 0) + 1;
      });
      return Object.keys(counts).map(function (t) {
        var n = counts[t];
        var label;
        if (t === 'battlemap') label = (n === 1 ? strings.packs_one : strings.packs_other) || 'map packs';
        else label = t + (n === 1 ? '' : 's'); // future creature/spell/item types until they get keys
        return n + ' ' + label;
      }).join(', ');
    }
    function block(title, items, cls) {
      if (!items || !items.length) return '';
      var lis = items.map(function (it) {
        var type = (!bundleMode && it.type) ? ' <span class="bc-type">' + esc(it.type) + '</span>' : '';
        var name = esc(it.name || it.id);
        var handle = memberHandleFor(it.name || '');
        if (handle) name = '<a href="/products/' + esc(handle) + '">' + name + '</a>';
        return '<li>' + name + type + '</li>';
      }).join('');
      var head = bundleMode
        ? esc(title) + ': ' + esc(typeSummary(items))
        : esc(title) + ' <span class="bc-n">' + items.length + '</span>';
      return '<div class="bc-block ' + cls + '"><div class="bc-h">' + head + '</div><ul>' + lis + '</ul></div>';
    }
    var html = '';
    html += block(strings.you_get || 'What you get', d.missing, 'bc-get');
    html += block(strings.you_own || 'You already own', d.owned, 'bc-own');
    html += block(strings.patreon_only || 'Only via Patreon', d.subscription_only, 'bc-sub');
    checklistEl.innerHTML = html;
    checklistEl.hidden = !html;
  }

  var wired = false;
  function wireCart() {
    if (wired || !form) return;
    wired = true;
    // Attach directly on the form so this runs BEFORE beneos.js's delegated document handler.
    // It ALWAYS claims the submit: the form of a shell holds no variant, and a submit that is
    // not a resolved cart add is either a retry or nothing.
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!resolved) { load(); return; }
      var groups = resolved.groups || [];
      if (!groups.length) return;

      var missing = (resolved && resolved.missing) || [];
      var idsByVariant = {};
      missing.forEach(function (it) {
        var v = numId(it.variant_id);
        (idsByVariant[v] = idsByVariant[v] || []).push(it.id);
      });

      // The cart line is technically the price_class variant ("Animated Map Pack - Medium"), so we
      // carry the real pack identity on the line so the buyer always sees WHAT they bought:
      //  - a visible property (Shopify shows it at checkout under the generic title)
      //  - hidden _pack_* properties the theme cart drawer renders as the real title/cover/summary.
      var packLabel = strings.pack_label || 'Pack';
      var packTitle = cfg.productTitle || '';
      var summary = buildSummary(cfg.facts, strings);
      var visibleValue = summary ? (packTitle + ': ' + summary) : packTitle;
      var items = groups.map(function (g) {
        var v = numId(g.variant_id);
        var props = {};
        props['_cloud_upload_ids'] = (idsByVariant[v] || []).join(','); // hidden (Spec 8.2)
        props[packLabel] = visibleValue;                                 // visible at checkout
        props['_pack_title'] = packTitle;                                // drawer: real name
        if (cfg.productUrl) props['_pack_url'] = cfg.productUrl;          // drawer: link to the pack
        if (cfg.productImage) props['_pack_thumb'] = cfg.productImage;    // drawer: cover thumbnail
        if (summary) props['_pack_summary'] = summary;                   // drawer: content reassurance
        return { id: v, quantity: g.qty, properties: props };
      });

      if (addBtn) addBtn.disabled = true;
      fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return (B.cart && B.cart.refresh) ? B.cart.refresh() : null; })
        .then(function () {
          if (B.cart && B.cart.open) B.cart.open();
          if (addBtn) addBtn.disabled = false;
        })
        .catch(function () { if (addBtn) addBtn.disabled = false; });
    });
  }
})();
